import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose' 
import { setLoading } from '../../../../redux/actions/actionsCallAPI'
import { getLoading } from '../../../../redux/selectors/selectorCallAPI' 
import { translate } from 'react-switch-lang'
import Loading from '../loading'

class LoadingModal extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			isLoading: false
		}
	}

	render() {
		const { loading, } = this.props
 
		return <Loading isActive={loading} />

	}
}

export default compose(
	withRouter,
	translate,
	connect(
		(state, props) => ({
			loading: getLoading(state)
		}),
		(dispatch, { history }) => ({
			setLoading(isLoading) {
				dispatch(setLoading(isLoading))
			}
		})
	),
	lifecycle({

	}),
)(LoadingModal)


// WEBPACK FOOTER //
// ./src/app/components/features/share/modal/loadingModal.js